<template>
  <AddEditTemplate
    v-if="formData && !loading"
    :isEditMode="isEditMode"
    addEditType="User"
    :initialData="formData"
    :submitAction="submitForm"
  >
    <template #default="{ formData }">
      <AddEditFormGroup
        label="Username"
        fieldId="username"
        v-model="formData.username"
        required
      />
      <AddEditFormGroup
        :label="isEditMode ? 'Update Password' : 'Password'"
        fieldId="password"
        v-model="formData.password"
        :required="!isEditMode"
      />
      <AddEditFormGroup
        label="First Name"
        fieldId="firstName"
        v-model="formData.firstName"
        required
      />
      <AddEditFormGroup
        label="Last Name"
        fieldId="lastName"
        v-model="formData.lastName"
        required
      />
      <AddEditFormGroup
        label="Email"
        fieldId="email"
        v-model="formData.email"
        type="email"
        required
      />
      <AddEditFormGroup
        label="Phone"
        fieldId="phone"
        v-model="formData.phone"
        type="tel"
      />
      <AddEditFormGroup
        label="Type"
        fieldId="userTypeId"
        v-model="formData.userTypeId"
        component="select"
        :options="userTypes"
        :disabled="isEditMode"
        required
      />
      <AddEditFormGroup
        label="Status"
        fieldId="userStatusId"
        v-model="formData.userStatusId"
        component="select"
        :options="userStatus"
        :disabled="!isEditMode"
        required
      />
    </template>
  </AddEditTemplate>
</template>

<script>
import AddEditTemplate from "./AddEditTemplate.vue";
import AddEditFormGroup from "./AddEditFormGroup.vue";
import UsersAPIService from "src/servicehandlers/UsersAPIService";
const usersAPIService = new UsersAPIService();
import ActiveInstructorsAPIService from "src/servicehandlers/ActiveInstructorsAPIService";
const activeInstructorsAPIService = new ActiveInstructorsAPIService();
import ActiveStudentsAPIService from "src/servicehandlers/ActiveStudentsAPIService";
const activeStudentsAPIService = new ActiveStudentsAPIService();
import DpeAPIService from "src/servicehandlers/DpeAPIService";
const dpeAPIService = new DpeAPIService();

export default {
  components: { AddEditFormGroup, AddEditTemplate },
  data() {
    return {
      isEditMode: false,
      loading: true,
      formData: {
        username: "",
        password: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        userTypeId: "",
        userStatusId: 1,
      },
      userTypes: [],
      userStatus: [],
      instructorType: {},
      studentType: {},
    };
  },
  async created() {
    if (this.$route.params.id) {
      this.isEditMode = true;
      await this.getUser(this.$route.params.id);
    }
    await Promise.all([this.getUserTypes(), this.getUserStatus()]);

    this.loading = false;
  },
  methods: {
    async getUser(id) {
      try {
        const response = await usersAPIService.getById(id);
        this.formData = {
          ...response,
          userTypeId: response.userType.id,
          userStatusId: response.userStatus.id,
          password: "",
        };
      } catch (error) {}
    },
    getUserTypes() {
      return usersAPIService
        .getUserTypes(this.$router)
        .then((types) => {
          this.userTypes = types;
          this.instructorType = types.find(
            (type) => type.name === "Instructor",
          );
          this.studentType = types.find((type) => type.name === "Student");
          this.dpeType = types.find((type) => type.name === "DPE");
        })
        .catch(() => {});
    },
    getUserStatus() {
      return usersAPIService
        .getUserStatusList(this.$router)
        .then((types) => {
          this.userStatus = types.filter((type) => type.name !== "Potential");
        })
        .catch(() => {});
    },
    async submitForm(formData) {
      try {
        if (this.isEditMode) {
          await usersAPIService.update(this.$route.params.id, formData);
        } else if (formData.userTypeId === this.instructorType?.id) {
          await activeInstructorsAPIService.create(formData);
        } else if (formData.userTypeId === this.studentType?.id) {
          await activeStudentsAPIService.create(formData);
        } else if (formData.userTypeId === this.dpeType?.id) {
          await dpeAPIService.create(formData);
        } else {
          await usersAPIService.create(formData);
        }
      } catch (error) {}
    },
  },
};
</script>

<style scoped></style>
